import React from "react";
import { Layout, Row, Col, Menu } from "antd";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import AppHeader from "./Header";
import { isLogin } from "../../utils/IsLogin";
import { useHistory } from "react-router";
import { ROUTES } from "../../routes/constant";
import { parseJwt } from "../../utils";
import useViewport from "../../hooks/useViewport";

const { Content } = Layout;

const { SubMenu } = Menu;

const AppLayout = (props) => {
  const {width, height} =useViewport()
  const isMobile = 1617 > width;
  const history = useHistory();
  const token = localStorage.getItem("USER_TOKEN");
  const userInfo = token !== null && parseJwt(token);
  return (
    <Layout>
      <AppHeader />

      <Content style={{ marginTop: 50, height: "97vh",background:"white" }}>
        <div style={{ margin: "16px 0" }}>
          <Row>
            <Col className="dekstop-menu" md={isLogin() ? !isMobile ? 3 : 0:0}>
              <Menu
                style={{
                  width: 220,
                  position: "fixed",
                  height: "100vh",
                  overflow: "auto",
                }}
                defaultSelectedKeys={["1"]}
                defaultOpenKeys={["sub1"]}
                mode="inline"
              >
                 <Menu.Item
                  onClick={() => {
                    history.push(ROUTES.HOME);
                  }}
                  icon={<AppstoreOutlined />}
                  key="555"
                >
                 Home
                </Menu.Item>
                {userInfo && userInfo?.payload?.type !== "guest" && (
                  <Menu.Item
                    onClick={() => {
                      history.push(ROUTES.PROFILE);
                    }}
                    icon={<UserOutlined />}
                    key="25"
                  >
                    My Profile
                  </Menu.Item>
                )}

                <Menu.Item
                  onClick={() => {
                    history.push(ROUTES.MANAGE_BOOKING);
                  }}
                  icon={<AppstoreOutlined />}
                  key="5"
                >
                  Manage Booking
                </Menu.Item>

                {userInfo && userInfo?.payload?.role === "1" && (
                  <Menu.Item
                    onClick={() => {
                      history.push(ROUTES.MY_PRODUCT);
                    }}
                    icon={<AppstoreOutlined />}
                    key="15"
                  >
                    My Product
                  </Menu.Item>
                )}

                <Menu.Item
                  onClick={() => {
                    history.push(ROUTES.STATISTICS);
                  }}
                  icon={<AppstoreOutlined />}
                  key="17"
                >
                  Statistics
                </Menu.Item>
              </Menu>
            </Col>
            <Col style={{width:"100%"}} xs={isLogin() ? !isMobile ? 20 : 24:24} xl={isLogin() ? !isMobile ? 20 : 24:24}>{props.children}</Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default AppLayout;
